import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/sign-up"
    },
    {
      path: "/sign-in",
      name: "sign-in",
      props: true,
      component: () =>
        import("@/views/SignIn")
    },
    {
      path: "/sign-up",
      name: "sign-up",
      props: true,
      component: () =>
        import("@/views/SignIn")
    },
    {
      path: "/trainer/sign-in",
      name: "trainer-sign-in",
      props: true,
      component: () =>
        import("@/views/SignIn")
    },
    {
      path: "/trainer/sign-up",
      name: "trainer-sign-up",
      props: true,
      component: () =>
        import("@/views/SignIn")
    },
    {
      path: "/calendar",
      name: "trainee-calendar",
      props: true,
      component: () =>
        import("@/views/TraineeCalendar")
    },
    {
      path: "/calendar/:eventId",
      name: "trainee-detail-event",
      props: true,
      component: () =>
        import("@/views/TraineeCalendar")
    },
    {
      path: "/trainer/calendar",
      name: "trainer-calendar",
      props: true,
      component: () =>
        import("@/views/TrainerCalendar")
    },
    {
      path: "/trainer/calendar/:eventId",
      name: "trainer-detail-event",
      props: true,
      component: () =>
        import("@/views/TrainerCalendar")
    },
    {
      path: "/trainer/calendar/:eventId/edit",
      name: "edit-event",
      props: true,
      component: () =>
        import("@/views/TrainerCalendar")
    },
    {
      path: "/trainee/:uid",
      name: "trainee-user",
      props: true,
      component: () =>
        import("@/views/User")
    },
    {
      path: "/trainer/:uid",
      name: "trainer-user",
      props: true,
      component: () =>
        import("@/views/User")
    },
    {
      path: "/room/:eventId/:uid",
      name: "room",
      props: true,
      component: () =>
        import("@/views/RoomToRedirect")
    },
    {
      path: "/tutorial",
      name: "tutorial",
      props: true,
      component: () =>
        import("@/views/Tutorial")
    },
    {
      path: "/tutorial/event/:eventId",
      name: "tutorial_event_detail",
      props: true,
      component: () =>
        import("@/views/Tutorial")
    },
    {
      path: "/counseling",
      name: "counseling",
      props: true,
      component: () =>
        import("@/views/Counseling")
    },
    {
      path: "/event_suggestion",
      name: "event_suggestion",
      props: true,
      component: () =>
        import("@/views/EventSuggestion")
    }
  ]
})
